// src/store/authStore.ts
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface RefAndEarnVisibleState {
  visible: boolean;
  show: () => void;
  hide: () => void;
  toggle: () => void;
}

export const useRefAndEarnVisibleStore = create<RefAndEarnVisibleState>()(
  immer((set) => ({
    visible: false,
    show: () => {
      set((state) => {
        state.visible = true;
      });
    },
    hide: () => {
      set((state) => {
        state.visible = false;
      });
    },
    toggle: () => {
      set((state) => {
        state.visible = !state.visible;
      });
    },
  }))
);
